<template>
    <div class="page-wrapper" :class="classObj">
        <div v-if="sidebar.opened" class="drawer-bg" @click="toggleSideBar"></div>
        <Navbar v-if="isShowNav" />
        <Sidebar />
        <div class="page-wrapper-main">
            <router-view />
        </div>
        <AddNewBtn v-show="isShowAddBtn" />
    </div>
</template>
<script>
    import Navbar from './components/Navbar';
    import Sidebar from './components/Sidebar';
    import AddNewBtn from './components/AddNewBtn';
    import ReCalcRem from './mixin/ReCalcRem';
    import { mapState } from 'vuex';

    export default {
        name: 'Container',
        components: {
            Navbar,
            Sidebar,
            AddNewBtn
        },
        mixins: [ReCalcRem],
        data() {
            return {
                isShowNav: false,
                isShowAddBtn: true
            }
        },
        computed: {
            ...mapState({
                sidebar: state => state.app.sidebar
            }),
            classObj() {
                return {
                    'sidebar-hide': !this.sidebar.opened,
                    'sidebar-show': this.sidebar.opened,
                    withoutAnimation: this.sidebar.withoutAnimation
                }
            }
        },
        created() {
            // 把是否显示新增按钮放到路由的meta中
            let { meta: { showAddBtn = false } } = this.$route;

            this.isShowAddBtn = showAddBtn;
            if (window.sma.isApp.innovationChina) {
                this.isShowNav = false;
            }
        },
        methods: {
            toggleSideBar() {
                this.$store.dispatch('app/toggleSideBar')
            },
            handleClickOutside() {
                this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
            }
        }
    };

</script>
<style lang="scss" scoped>
.page-wrapper {
    .drawer-bg {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .4);
        z-index: 999;
    }
}

</style>
